import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

export default class Reveal {

  constructor(selector) {
    // kill triggers of the previous page (barba re-instantiates Reveal)
    if (Reveal.triggers) {
      Reveal.triggers.forEach((trigger) => trigger.kill());
    }
    Reveal.triggers = [];

    const wrappers = document.querySelectorAll(selector);
    if (!wrappers.length) {
      return;
    }

    // collect items once — wrappers can be nested, avoid duplicate triggers
    const items = [];
    for (let i = 0; i < wrappers.length; i++) {
      const found = wrappers[i].querySelectorAll('.reveal');
      for (let j = 0; j < found.length; j++) {
        if (!items.includes(found[j])) {
          items.push(found[j]);
        }
      }
    }
    if (!items.length) {
      return;
    }

    // stagger only within the batch of items entering the viewport together;
    // no stagger at all on fast scrolls so nothing sits invisible in view
    const show = (elements, triggers) => {
      const velocity = triggers.length ? Math.abs(triggers[0].getVelocity()) : 0;
      const stagger = velocity > 1000 ? 0 : 100;
      elements.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add('reveal__show');
        }, Math.min(index * stagger, 400));
      });
    };

    Reveal.triggers = ScrollTrigger.batch(items, {
      start: "top bottom",
      end: "bottom top",
      interval: 0.1,
      onEnter: show,
      onEnterBack: show,
    });

  }

}
